import { Box, Center, Flex, Grid, Wrap } from "@chakra-ui/react";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { postActions } from "../../../redux/actions";
import Navbar from "../Navbar/Navbar";
import Jobrole_Comp from "./Jobrole_Comp";
import * as api from "../../../services/api";
const Jobs_tab = () => {
  // const { companyId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [company, setCompany] = useState({});
  const posts = useSelector((state) => state.post.data);
  const user = JSON.parse(localStorage.getItem("user"));
  
  const companyId = user.companyId;
  useEffect(() => {
    api.getCompanyById(companyId).then((res) => setCompany(res.data.data));
    dispatch(postActions.getPosts(companyId, "active"));
  }, []);
  return (
    <div>
      <Flex mt={10}>
        <Wrap
          templateColumns="repeat(4, 1fr)"
          gap={5}
          mt={10}
        >
          {posts?.map((elem) => (
            <Jobrole_Comp
              key={elem._id}
              role={elem.jobRoleTitle}
              company={company?.companyName}
              id={elem._id}
              recruiter={elem.createdBy}
            />
          ))}
        </Wrap>
      </Flex>
    </div>
  );
};
export default Jobs_tab;
